import actionTypes from '../../actions/action-types';

export default (state = '', action) => {
  switch (action.type) {
    case actionTypes.SET_ACTIVE_TAB: {
      return action.tab;
    }
    default:
      return state;
  }
};





// WEBPACK FOOTER //
// ./src/modules/utils/reducers/active-tab/active-tab.js